const callerId = {
    name: 'Caller ID',
    value: 'callerId',
    sortSettings: {
        key: '',
        sortBy: 'byCallerId',
    },
    filterSettings: {},
    disabled: true,
    editAction: true,
    grow: true,
    minWidth: 130,
}

const status = {
    name: 'Status',
    value: 'status',
    align: 'center',
    sortSettings: {
        key: '',
        sortBy: 'byStatus',
    },
    filterSettings: {},
    minWidth: 100,
}

const createdAt = {
    name: 'Created at',
    value: 'created_at',
    insertContent: true,
}

const zipCode = {
    name: 'Zip code',
    value: 'zipCode',
    sortSettings: {
        key: '',
        sortBy: 'byZipCode',
    },
    filterSettings: {},
    activeDefault: false,
    minWidth: 80,
}

const firstName = {
    name: 'First name',
    value: 'firstName',
    sortSettings: {
        key: '',
        sortBy: 'byFirstName',
    },
    filterSettings: {},
    minWidth: 100,
}

const lastName = {
    name: 'Last name',
    value: 'lastName',
    sortSettings: {
        key: '',
        sortBy: 'byLastName',
    },
    filterSettings: {},
    minWidth: 100,
}

const email = {
    name: 'Email',
    value: 'email',
    sortSettings: {
        key: '',
        sortBy: 'byEmail',
    },
    filterSettings: {},
    minWidth: 120,
}

const campaign = {
    name: 'Campaign',
    value: 'campaign',
    sortSettings: {
        key: '',
        sortBy: 'byCampaign',
    },
    filterSettings: {},
    minWidth: 100,
}

const vendor = {
    name: 'Vendor',
    value: 'vendor',
    sortSettings: {
        key: '',
        sortBy: 'byVendor',
    },
    filterSettings: {},
    minWidth: 100,
}

const actions = {
    name: 'Actions',
    value: 'actions',
    minWidth: 80,
    align: 'center',
    disabled: true,
}

export const LEADS_HEADERS = [
    callerId,
    status,
    createdAt,
    zipCode,
    firstName,
    lastName,
    email,
    campaign,
    vendor,
    actions,
]

export const LEADS_HEADERS_FOR_VENDOR = [
    callerId,
    status,
    createdAt,
    zipCode,
    firstName,
    lastName,
    email,
    campaign,
]
